import * as React from 'react';
import UISetting from '../../MakeDonation/Types/UISetting';

/**
 * This is a compositional component that controls how child components
 * get rendered. Without any additional properties, it will render only
 * the child with index = displayIndex, i.e. displayIndex = 2, will
 * render the 3rd child.
 *
 * Setting the optional property 'displayAllChildren' = true,
 * will render all the children normally, almost as if this component
 * wasn't used.
 *
 * 'renderSteps' is an optional method rendered before any children, it
 * can be used to generate the 'Progress' header as a user steps
 * through form views.
 */

interface Props {
  displayIndex: number;
  children?: React.ReactNode;
  displayAllChildren?: boolean;
  renderSteps?(count: number, displayIndex: number, children?: React.ReactChild[], uiSetting?: UISetting): JSX.Element | undefined;
}

class ComponentSequence extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let renderable;
    const view = React.Children.toArray(this.props.children);

    if (this.props.displayAllChildren) {
      renderable = [ this.props.children ];
    } else {
      renderable = view.map((child, index) => {
        if (index === this.props.displayIndex) {
          return child;
        }

        return;
      });
    }

    if (this.props.renderSteps) {
      return this.props.renderSteps(view.length, this.props.displayIndex, view);
    }

    return renderable;
  }
}

export default ComponentSequence;



// WEBPACK FOOTER //
// ./src/Components/Compositional/ComponentSequence.tsx